import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChronopost = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#00A9E3"
	}), /* @__PURE__ */ _jsx("g", {
		transform: "translate(7 7) scale(0.160124) translate(9.705 2.041)",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-1753.26 -117.982) scale(4.16667)",
			children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0-2.786a.393.393 0 0 1-.371-.007l-.603-.358a.395.395 0 0 1-.128-.137l-.006-.011a.402.402 0 0 1-.062-.189l-.016-.703a.396.396 0 0 1 .179-.324l7.241-4.218-10.161-5.538a.863.863 0 0 0-.407-.092.852.852 0 0 0-.408.092l-10.161 5.538L-3.52-2.106a.387.387 0 0 1 .186.318v9.667a.391.391 0 0 1-.194.317l-.612.341a.398.398 0 0 1-.183.041h-.012a.405.405 0 0 1-.196-.041l-.614-.341a.389.389 0 0 1-.19-.317V-.739a.242.242 0 0 0-.102-.169l-10.029-5.838V4.689a.9.9 0 0 0 .402.701l10.328 6.091a.81.81 0 0 0 .402.097.82.82 0 0 0 .401-.096L6.397 5.39c.22-.131.4-.445.4-.701V-6.746L0-2.786",
					transform: "translate(436.277 42.708)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("g", {
					transform: "matrix(.24038 0 0 .24182 431.977 28.115)",
					children: /* @__PURE__ */ _jsx("g", {})
				}), /* @__PURE__ */ _jsx("g", {
					transform: "matrix(12.55 0 0 13.3001 430.725 41.115)",
					children: /* @__PURE__ */ _jsx("g", {})
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("g", {
						transform: "matrix(.2365 0 0 .24286 421.234 28.115)",
						children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("use", {
							href: "#j",
							x: 1.884,
							y: .121,
							width: 89,
							height: 28,
							transform: "matrix(1.01483 0 0 .98823 -1.912 .828)"
						}) }) })
					}),
					/* @__PURE__ */ _jsx("g", {
						transform: "matrix(.23737 0 0 .24286 420.725 34.615)",
						children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("use", {
							href: "#m",
							x: .121,
							y: 27.063,
							width: 93,
							height: 28,
							transform: "matrix(1.01109 0 0 .98823 .24 -25.937)"
						}) }) })
					}),
					/* @__PURE__ */ _jsx("g", {
						transform: "matrix(.23737 0 0 .24286 420.725 41.115)",
						children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("use", {
							href: "#p",
							x: .121,
							y: 54.058,
							width: 93,
							height: 28,
							transform: "matrix(1.01109 0 0 .98823 .24 -52.701)"
						}) }) })
					}),
					/* @__PURE__ */ _jsx("g", {
						transform: "matrix(.23726 0 0 .24286 420.725 47.615)",
						children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("use", {
							href: "#s",
							x: .121,
							y: 81.121,
							width: 93,
							height: 28,
							transform: "matrix(1.01154 0 0 .98823 .24 -79.466)"
						}) }) })
					})
				] })
			] })
		})
	})]
});
export default SvgChronopost;
